import { useNavigate, useSearchParams } from "@remix-run/react";
import { TabKey } from "../types";

/**
 * Custom hook for handling tab navigation
 * Manages URL search parameters and provides tab switching functionality
 */
export function useTabNavigation() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  /**
   * Navigate to a specific tab
   * @param tabValue - The tab key to navigate to
   * @param event - Optional mouse event to prevent default behavior
   */
  const navigateToTab = (tabValue: TabKey, event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Update URL search params without scrolling
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("tab", tabValue);

    // Use navigate with preventScrollReset option
    navigate(`?${newSearchParams.toString()}#leadership-section`, {
      replace: true,
      preventScrollReset: true,
      viewTransition: true,
    });
  };

  return {
    searchParams,
    navigateToTab,
  };
}
